"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductCategoryChange_1 = require("../model/ProductCategoryChange");

var ProductCategoryChangeConverter_1 = require("./ProductCategoryChangeConverter");
/**
 * Default implementation of {@link ProductCategoryChangeConverter}.
 *
 * @author Radek Beran
 */


var ProductCategoryChangeConverterImpl =
/*#__PURE__*/
function (_ProductCategoryChang) {
  _inherits(ProductCategoryChangeConverterImpl, _ProductCategoryChang);

  function ProductCategoryChangeConverterImpl() {
    _classCallCheck(this, ProductCategoryChangeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryChangeConverterImpl).apply(this, arguments));
  }

  _createClass(ProductCategoryChangeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductCategoryChange_1.ProductCategoryChange(ProductCategoryChange_1.ProductCategoryChange.schema.id.valueOf(conversions.documentToClassId(source)), ProductCategoryChange_1.ProductCategoryChange.schema.transferLogId.valueOf(conversions.toClassReferenceId(source.transferLogId)), ProductCategoryChange_1.ProductCategoryChange.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductCategoryChange_1.ProductCategoryChange.schema.oldCategoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'oldCategoryIds')), ProductCategoryChange_1.ProductCategoryChange.schema.newCategoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'newCategoryIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        transferLogId: conversions.toDocumentReferenceId(source.transferLogId),
        productId: conversions.toDocumentReferenceId(source.productId),
        oldCategoryIds: conversions.asObjectArray(source, 'oldCategoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        newCategoryIds: conversions.asObjectArray(source, 'newCategoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        changedFromLevel: source.changedFromLevel
      });
      return result;
    }
  }]);

  return ProductCategoryChangeConverterImpl;
}(ProductCategoryChangeConverter_1.ProductCategoryChangeConverter);

exports.ProductCategoryChangeConverterImpl = ProductCategoryChangeConverterImpl;